var exports = {
  "q": "sortGroupMobileOnly__pBSOWY",
  "h": "sortLabel__FLknEp",
};

module.exports = exports;
